import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getMyOrganization } from '../services/api';
import Icon from './Icon';
import { storage } from '../utils/storage';
import './OrganizationSelector.css';

function OrganizationSelector({ onOrganizationChange }) {
  const { t } = useTranslation();
  const [organizations, setOrganizations] = useState([]);
  const [selectedOrgId, setSelectedOrgId] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadOrganizations();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadOrganizations = async () => {
    try {
      const data = await getMyOrganization();
      const orgs = data.organizations || [];
      setOrganizations(orgs);

      // Obtener organización seleccionada del localStorage
      const savedOrgId = storage.get('selectedOrganizationId');

      if (savedOrgId && orgs.find((o) => o.organizationId === savedOrgId)) {
        setSelectedOrgId(savedOrgId);
      } else if (orgs.length > 0) {
        // Auto-seleccionar la primera organización
        const firstOrg = orgs[0];
        handleOrganizationChange(firstOrg.organizationId);
      }
    } catch (error) {
      console.error('Error loading organizations:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleOrganizationChange = (organizationId) => {
    setSelectedOrgId(organizationId);
    storage.set('selectedOrganizationId', organizationId);

    // Encontrar la organización seleccionada y guardar info adicional
    const organization = organizations.find((o) => o.organizationId === organizationId);
    if (organization) {
      storage.set('selectedOrganizationName', organization.name);
      storage.set('userRole', organization.userRole);
      storage.set('allRestaurants', organization.allRestaurants);
    }

    // Limpiar restaurante seleccionado al cambiar de organización
    storage.remove('selectedRestaurantId');
    storage.remove('selectedRestaurantName');

    // Notificar al componente padre si existe callback
    if (onOrganizationChange) {
      onOrganizationChange(organizationId, organization);
    }

    // Recargar la página para aplicar cambios
    window.location.reload();
  };

  if (loading) {
    return <div className="organization-selector loading">{t('common.loading')}</div>;
  }

  if (organizations.length === 0) {
    return (
      <div className="organization-selector empty">
        <Icon name="business" size="small" />
        <span>No hay organizaciones</span>
      </div>
    );
  }

  const selectedOrg = organizations.find((o) => o.organizationId === selectedOrgId);

  return (
    <div className="organization-selector">
      <Icon name="business" size="small" />
      <select
        value={selectedOrgId}
        onChange={(e) => handleOrganizationChange(e.target.value)}
        className="organization-select"
        title={selectedOrg ? `${selectedOrg.name} (${selectedOrg.userRole})` : ''}
      >
        <option value="">Seleccionar organización</option>
        {organizations.map((org) => (
          <option
            key={org.organizationId}
            value={org.organizationId}
            title={`${org.name} (${org.userRole})`}
          >
            {org.name} ({org.userRole})
          </option>
        ))}
      </select>
      {selectedOrg && (
        <span className="selected-organization-badge">
          {selectedOrg.status === 'active' ? '✓' : '⚠️'}
        </span>
      )}
    </div>
  );
}

export default OrganizationSelector;
